import { aiExperienceApplicationMessages } from '@atlaskit/editor-common/ai-messages';
export var mapLoadingStatusToMessageTemplate = function mapLoadingStatusToMessageTemplate(messageTemplate) {
  switch (messageTemplate) {
    case 'ANALYSING_QUERY':
      return aiExperienceApplicationMessages.messageTemplateAnalysingQuery;
    case 'CONTENT_SEARCH':
      return aiExperienceApplicationMessages.messageTemplateContentSearch;
    case 'PAGE_HYDRATION':
      return aiExperienceApplicationMessages.messageTemplatePageHydration;
    case 'NEXT_BEST_TASK':
      return aiExperienceApplicationMessages.messageTemplateNextBestTask;
    case 'WRITING':
      return aiExperienceApplicationMessages.loadingTitle;
    default:
      return;
  }
};